var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("Envoi de codes promotionnels")]),_vm._v(" "),_c('p',[_vm._v("L'équipe de "+_vm._s(_vm.host)+" vous remercie de votre confiance. En signe d'appréciation, nous enverrons périodiquement des codes promotionnels aux joueurs réguliers. Profitez du jeu!")])])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// c:/Jenkins/workspace/play-at-home-test-frontend-deploy-sites/src/onlinecasino/OnlineCasino.Web.Public/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!c:/Jenkins/workspace/play-at-home-test-frontend-deploy-sites/src/onlinecasino/OnlineCasino.Web.Public/node_modules/vue-loader/lib??vue-loader-options!./skins/bulmasite/components/pages/sitepages/bonus-rules/bonus-rules-mailing/fr.vue?vue&type=template&id=8fa9c972
// module id = VBgP
// module chunks = 0